<template>
    <div class="carousel--wrapper">
        <agile :autoplay="true" :navButtons="false" :autoplaySpeed="7000" :speed="500">
            <div v-for="(item,key) in items" :key="key" class="slide">
                <div class="carousel--left">
                    <div class="carousel--image" v-if="item.image[0]">
                        <img :src="imageUrl(item.image[0])" :alt="item.title" />
                    </div>
                    <div class="carousel--icon--attribution" v-if="item.attribution"></div>
                </div>
                <div class="carousel--content carousel--right" >
                    <div class="carousel--title" v-if="item.title">{{ item.title }}</div>
                    <div class="carousel--body" v-html="item.content" />
                    <div class="carousel--attribution" v-if="item.attribution">{{ item.attribution }}</div>
                </div>
            </div>
        </agile>
  </div>
</template>

<script>
import { VueAgile } from 'vue-agile'

import { developmentFixImageUrls } from '../helpers'


export default {
  name: "Carousel",
  components: {
    agile: VueAgile 
  },
  props: {
      items: {
          type: Object,
          default: function () {
              return {}
          }
      }
  },
  data() {
    return {
        errors: []
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    resize() {},
    init() {

    },
    imageUrl(image) {
      //Only in development
      if (process.env.NODE_ENV == 'development') {
        return developmentFixImageUrls(image.imageUrl);
      }
      return image.imageUrl;
    }
  },
  computed: {
  }
};
</script>

<style scoped lang="scss">
    .carousel--image img {
        width: 100%;
    }
</style>